import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { fonts } from "../../theme/tokens";

// XLerate wordmark — black square + gold X + cyan dot, with serif wordmark
// and "BY XL@PROPERTY" eyebrow.
export default function Logo({ dark = false, lg = false, withEyebrow = true }) {
  const theme = useTheme();
  const fg = dark ? "#ffffff" : theme.palette.brand.ink;
  const eyebrowColor = dark ? "rgba(255,255,255,0.5)" : theme.palette.brand.inkSoft;
  const sz = lg ? 36 : 28;
  const titleSize = lg ? 22 : 17;
  const eyebrowSize = lg ? 8.5 : 7.5;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: lg ? 1.5 : 1.125 }}>
      <svg width={sz} height={sz} viewBox="0 0 32 32" fill="none">
        <rect width="32" height="32" rx="6" fill={theme.palette.brand.black} />
        <path
          d="M9 9l14 14M23 9 9 23"
          stroke={theme.palette.brand.gold}
          strokeWidth="2.6"
          strokeLinecap="round"
        />
        <circle cx="16" cy="16" r="2" fill={theme.palette.brand.cyan} />
      </svg>
      <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
        <Typography
          sx={{
            fontFamily: fonts.serif,
            fontWeight: 700,
            fontSize: titleSize,
            color: fg,
            letterSpacing: "-0.02em",
            lineHeight: 1,
          }}
        >
          XLerate
        </Typography>
        {withEyebrow && (
          <Box
            sx={{
              fontSize: eyebrowSize,
              letterSpacing: "0.22em",
              color: eyebrowColor,
              fontWeight: 600,
              mt: "2px",
              textTransform: "uppercase",
            }}
          >
            by XL@Property
          </Box>
        )}
      </Box>
    </Box>
  );
}
